import React from 'react';

const PainelAdminContext = React.createContext();

export default PainelAdminContext;